import { CSSProperties } from 'react';
import { grey } from 'assets/colors';
import { SxProps } from 'components/base';

export const iconDiv: SxProps = {
  width: '64px !important',
  height: '64px !important',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
};

export const otpInputStyle: CSSProperties = {
  width: '40px',
  height: '40px',
  fontSize: '16px',
  borderRadius: '4px',
  border: `1px solid ${grey.g400}`,
};

export const otpInputContainerStyle: CSSProperties = {
  alignSelf: 'center',
  gap: '10px',
  padding: '16px 0',
};
